require("jquery.inputmask");

$(function() {
	$(".mask-phone").inputmask('+7 (999) 999-99-99', { showMaskOnHover: false });
});
